import _defineProperty from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { invariant } from 'hey-listen';
import { PanSession } from '../PanSession.mjs';
import { getGlobalLock } from './utils/lock.mjs';
import { isRefObject } from '../../utils/is-ref-object.mjs';
import { addPointerEvent } from '../../events/use-pointer-event.mjs';
import { applyConstraints, calcRelativeConstraints, resolveDragElastic, rebaseAxisConstraints, calcViewportConstraints, calcOrigin, defaultElastic } from './utils/constraints.mjs';
import { AnimationType } from '../../render/utils/types.mjs';
import { createBox } from '../../projection/geometry/models.mjs';
import { eachAxis } from '../../projection/utils/each-axis.mjs';
import { measurePageBox } from '../../projection/utils/measure.mjs';
import { extractEventInfo } from '../../events/event-info.mjs';
import { startAnimation } from '../../animation/utils/transitions.mjs';
import { convertBoxToBoundingBox, convertBoundingBoxToBox } from '../../projection/geometry/conversion.mjs';
import { addDomEvent } from '../../events/use-dom-event.mjs';
import { percent } from 'style-value-types';
import { calcLength } from '../../projection/geometry/delta-calc.mjs';
import { mix } from '../../utils/mix.mjs';
var elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: AnyPointerEvent
var VisualElementDragControls = /*#__PURE__*/function () {
  function VisualElementDragControls(visualElement) {
    _classCallCheck(this, VisualElementDragControls);
    // This is a reference to the global drag gesture lock, ensuring only one component
    // can "capture" the drag of one or both axes.
    // TODO: Look into moving this into pansession?
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = {
      x: 0,
      y: 0
    };
    /**
     * The permitted boundaries of travel, in pixels.
     */
    this.constraints = false;
    this.hasMutatedConstraints = false;
    /**
     * The per-axis resolved elastic values.
     */
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  _createClass(VisualElementDragControls, [{
    key: "start",
    value: function start(originEvent) {
      var _this = this;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$snapToCursor = _ref.snapToCursor,
        snapToCursor = _ref$snapToCursor === void 0 ? false : _ref$snapToCursor;
      /**
       * Don't start dragging if this component is exiting
       */
      if (this.visualElement.isPresent === false) return;
      var onSessionStart = function onSessionStart(event) {
        // Stop any animations on both axis values immediately. This allows the user to throw and catch
        // the component.
        _this.stopAnimation();
        if (snapToCursor) {
          _this.snapToCursor(extractEventInfo(event, "page").point);
        }
      };
      var onStart = function onStart(event, info) {
        var _a;
        // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
        var _this$getProps = _this.getProps(),
          drag = _this$getProps.drag,
          dragPropagation = _this$getProps.dragPropagation,
          onDragStart = _this$getProps.onDragStart;
        if (drag && !dragPropagation) {
          if (_this.openGlobalLock) _this.openGlobalLock();
          _this.openGlobalLock = getGlobalLock(drag);
          // If we don 't have the lock, don't start dragging
          if (!_this.openGlobalLock) return;
        }
        _this.isDragging = true;
        _this.currentDirection = null;
        _this.resolveConstraints();
        if (_this.visualElement.projection) {
          _this.visualElement.projection.isAnimationBlocked = true;
          _this.visualElement.projection.target = undefined;
        }
        /**
         * Record gesture origin
         */
        eachAxis(function (axis) {
          var _a, _b;
          var current = _this.getAxisMotionValue(axis).get() || 0;
          /**
           * If the MotionValue is a percentage value convert to px
           */
          if (percent.test(current)) {
            var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.layoutBox[axis];
            if (measuredAxis) {
              var length = calcLength(measuredAxis);
              current = length * (parseFloat(current) / 100);
            }
          }
          _this.originPoint[axis] = current;
        });
        // Fire onDragStart event
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
        (_a = _this.visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Drag, true);
      };
      var onMove = function onMove(event, info) {
        // latestPointerEvent = event
        var _this$getProps2 = _this.getProps(),
          dragPropagation = _this$getProps2.dragPropagation,
          dragDirectionLock = _this$getProps2.dragDirectionLock,
          onDirectionLock = _this$getProps2.onDirectionLock,
          onDrag = _this$getProps2.onDrag;
        // If we didn't successfully receive the gesture lock, early return.
        if (!dragPropagation && !_this.openGlobalLock) return;
        var offset = info.offset;
        // Attempt to detect drag direction if directionLock is true
        if (dragDirectionLock && _this.currentDirection === null) {
          _this.currentDirection = getCurrentDirection(offset);
          // If we've successfully set a direction, notify listener
          if (_this.currentDirection !== null) {
            onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(_this.currentDirection);
          }
          return;
        }
        // Update each point with the latest position
        _this.updateAxis("x", info.point, offset);
        _this.updateAxis("y", info.point, offset);
        /**
         * Ideally we would leave the renderer to fire naturally at the end of
         * this frame but if the element is about to change layout as the result
         * of a re-render we want to ensure the browser can read the latest
         * bounding box to ensure the pointer and element don't fall out of sync.
         */
        _this.visualElement.render();
        /**
         * This must fire after the render call as it might trigger a state
         * change which itself might trigger a layout update.
         */
        onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
      };
      var onSessionEnd = function onSessionEnd(event, info) {
        return _this.stop(event, info);
      };
      this.panSession = new PanSession(originEvent, {
        onSessionStart: onSessionStart,
        onStart: onStart,
        onMove: onMove,
        onSessionEnd: onSessionEnd
      }, {
        transformPagePoint: this.visualElement.getTransformPagePoint()
      });
    }
  }, {
    key: "stop",
    value: function stop(event, info) {
      var isDragging = this.isDragging;
      this.cancel();
      if (!isDragging) return;
      var velocity = info.velocity;
      this.startAnimation(velocity);
      var _this$getProps3 = this.getProps(),
        onDragEnd = _this$getProps3.onDragEnd;
      onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _a, _b;
      this.isDragging = false;
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = false;
      }
      (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
      this.panSession = undefined;
      var _this$getProps4 = this.getProps(),
        dragPropagation = _this$getProps4.dragPropagation;
      if (!dragPropagation && this.openGlobalLock) {
        this.openGlobalLock();
        this.openGlobalLock = null;
      }
      (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    }
  }, {
    key: "updateAxis",
    value: function updateAxis(axis, _point, offset) {
      var _this$getProps5 = this.getProps(),
        drag = _this$getProps5.drag;
      // If we're not dragging this axis, do an early return.
      if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
      var axisValue = this.getAxisMotionValue(axis);
      var next = this.originPoint[axis] + offset[axis];
      // Apply constraints
      if (this.constraints && this.constraints[axis]) {
        next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
      }
      axisValue.set(next);
    }
  }, {
    key: "resolveConstraints",
    value: function resolveConstraints() {
      var _this2 = this;
      var _this$getProps6 = this.getProps(),
        dragConstraints = _this$getProps6.dragConstraints,
        dragElastic = _this$getProps6.dragElastic;
      var _ref2 = this.visualElement.projection || {},
        layout = _ref2.layout;
      var prevConstraints = this.constraints;
      if (dragConstraints && isRefObject(dragConstraints)) {
        if (!this.constraints) {
          this.constraints = this.resolveRefConstraints();
        }
      } else {
        if (dragConstraints && layout) {
          this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
        } else {
          this.constraints = false;
        }
      }
      this.elastic = resolveDragElastic(dragElastic);
      /**
       * If we're outputting to external MotionValues, we want to rebase the measured constraints
       * from viewport-relative to component-relative.
       */
      if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) {
        eachAxis(function (axis) {
          if (_this2.getAxisMotionValue(axis)) {
            _this2.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], _this2.constraints[axis]);
          }
        });
      }
    }
  }, {
    key: "resolveRefConstraints",
    value: function resolveRefConstraints() {
      var _this$getProps7 = this.getProps(),
        constraints = _this$getProps7.dragConstraints,
        onMeasureDragConstraints = _this$getProps7.onMeasureDragConstraints;
      if (!constraints || !isRefObject(constraints)) return false;
      var constraintsElement = constraints.current;
      invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var projection = this.visualElement.projection;
      // TODO
      if (!projection || !projection.layout) return false;
      var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
      var measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
      /**
       * If there's an onMeasureDragConstraints listener we call it and
       * if different constraints are returned, set constraints to that
       */
      if (onMeasureDragConstraints) {
        var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
        this.hasMutatedConstraints = !!userConstraints;
        if (userConstraints) {
          measuredConstraints = convertBoundingBoxToBox(userConstraints);
        }
      }
      return measuredConstraints;
    }
  }, {
    key: "startAnimation",
    value: function startAnimation(velocity) {
      var _this3 = this;
      var _this$getProps8 = this.getProps(),
        drag = _this$getProps8.drag,
        dragMomentum = _this$getProps8.dragMomentum,
        dragElastic = _this$getProps8.dragElastic,
        dragTransition = _this$getProps8.dragTransition,
        dragSnapToOrigin = _this$getProps8.dragSnapToOrigin,
        onDragTransitionEnd = _this$getProps8.onDragTransitionEnd;
      var constraints = this.constraints || {};
      var momentumAnimations = eachAxis(function (axis) {
        var _a;
        if (!shouldDrag(axis, drag, _this3.currentDirection)) {
          return;
        }
        var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
        if (dragSnapToOrigin) transition = {
          min: 0,
          max: 0
        };
        /**
         * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
         * of spring animations so we should look into adding a disable spring option to `inertia`.
         * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
         * using the value of `dragElastic`.
         */
        var bounceStiffness = dragElastic ? 200 : 1000000;
        var bounceDamping = dragElastic ? 40 : 10000000;
        var inertia = _objectSpread(_objectSpread({
          type: "inertia",
          velocity: dragMomentum ? velocity[axis] : 0,
          bounceStiffness: bounceStiffness,
          bounceDamping: bounceDamping,
          timeConstant: 750,
          restDelta: 1,
          restSpeed: 10
        }, dragTransition), transition);
        // If we're not animating on an externally-provided `MotionValue` we can use the
        // component's animation controls which will handle interactions with whileHover (etc),
        // otherwise we just have to animate the `MotionValue` itself.
        return _this3.startAxisValueAnimation(axis, inertia);
      });
      // Run all animations and then resolve the new drag constraints.
      return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
  }, {
    key: "startAxisValueAnimation",
    value: function startAxisValueAnimation(axis, transition) {
      var axisValue = this.getAxisMotionValue(axis);
      return startAnimation(axis, axisValue, 0, transition);
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      var _this4 = this;
      eachAxis(function (axis) {
        return _this4.getAxisMotionValue(axis).stop();
      });
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
  }, {
    key: "getAxisMotionValue",
    value: function getAxisMotionValue(axis) {
      var _a, _b;
      var dragKey = "_drag" + axis.toUpperCase();
      var externalMotionValue = this.visualElement.getProps()[dragKey];
      return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    }
  }, {
    key: "snapToCursor",
    value: function snapToCursor(point) {
      var _this5 = this;
      eachAxis(function (axis) {
        var _this5$getProps = _this5.getProps(),
          drag = _this5$getProps.drag;
        // If we're not dragging this axis, do an early return.
        if (!shouldDrag(axis, drag, _this5.currentDirection)) return;
        var projection = _this5.visualElement.projection;
        var axisValue = _this5.getAxisMotionValue(axis);
        if (projection && projection.layout) {
          var _projection$layout$la = projection.layout.layoutBox[axis],
            min = _projection$layout$la.min,
            max = _projection$layout$la.max;
          axisValue.set(point[axis] - mix(min, max, 0.5));
        }
      });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
  }, {
    key: "scalePositionWithinConstraints",
    value: function scalePositionWithinConstraints() {
      var _this6 = this;
      var _a;
      if (!this.visualElement.current) return;
      var _this$getProps9 = this.getProps(),
        drag = _this$getProps9.drag,
        dragConstraints = _this$getProps9.dragConstraints;
      var projection = this.visualElement.projection;
      if (!isRefObject(dragConstraints) || !projection || !this.constraints) return;
      /**
       * Stop current animations as there can be visual glitching if we try to do
       * this mid-animation
       */
      this.stopAnimation();
      /**
       * Record the relative position of the dragged element relative to the
       * constraints box and save as a progress value.
       */
      var boxProgress = {
        x: 0,
        y: 0
      };
      eachAxis(function (axis) {
        var axisValue = _this6.getAxisMotionValue(axis);
        if (axisValue) {
          var latest = axisValue.get();
          boxProgress[axis] = calcOrigin({
            min: latest,
            max: latest
          }, _this6.constraints[axis]);
        }
      });
      /**
       * Update the layout of this element and resolve the latest drag constraints
       */
      var _this$visualElement$g = this.visualElement.getProps(),
        transformTemplate = _this$visualElement$g.transformTemplate;
      this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
      (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
      projection.updateLayout();
      this.resolveConstraints();
      /**
       * For each axis, calculate the current progress of the layout axis
       * within the new constraints.
       */
      eachAxis(function (axis) {
        if (!shouldDrag(axis, drag, null)) return;
        /**
         * Calculate a new transform based on the previous box progress
         */
        var axisValue = _this6.getAxisMotionValue(axis);
        var _this6$constraints$ax = _this6.constraints[axis],
          min = _this6$constraints$ax.min,
          max = _this6$constraints$ax.max;
        axisValue.set(mix(min, max, boxProgress[axis]));
      });
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this7 = this;
      var _a;
      if (!this.visualElement.current) return;
      elementDragControls.set(this.visualElement, this);
      var element = this.visualElement.current;
      /**
       * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
       */
      var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
        var _this7$getProps = _this7.getProps(),
          drag = _this7$getProps.drag,
          _this7$getProps$dragL = _this7$getProps.dragListener,
          dragListener = _this7$getProps$dragL === void 0 ? true : _this7$getProps$dragL;
        drag && dragListener && _this7.start(event);
      });
      var measureDragConstraints = function measureDragConstraints() {
        var _this7$getProps2 = _this7.getProps(),
          dragConstraints = _this7$getProps2.dragConstraints;
        if (isRefObject(dragConstraints)) {
          _this7.constraints = _this7.resolveRefConstraints();
        }
      };
      var projection = this.visualElement.projection;
      var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
      if (projection && !projection.layout) {
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
      }
      measureDragConstraints();
      /**
       * Attach a window resize listener to scale the draggable target within its defined
       * constraints as the window resizes.
       */
      var stopResizeListener = addDomEvent(window, "resize", function () {
        return _this7.scalePositionWithinConstraints();
      });
      /**
       * If the element's layout changes, calculate the delta and apply that to
       * the drag gesture's origin point.
       */
      var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function (_ref3) {
        var delta = _ref3.delta,
          hasLayoutChanged = _ref3.hasLayoutChanged;
        if (_this7.isDragging && hasLayoutChanged) {
          eachAxis(function (axis) {
            var motionValue = _this7.getAxisMotionValue(axis);
            if (!motionValue) return;
            _this7.originPoint[axis] += delta[axis].translate;
            motionValue.set(motionValue.get() + delta[axis].translate);
          });
          _this7.visualElement.render();
        }
      });
      return function () {
        stopResizeListener();
        stopPointerListener();
        stopMeasureLayoutListener();
        stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
      };
    }
  }, {
    key: "getProps",
    value: function getProps() {
      var props = this.visualElement.getProps();
      var _props$drag = props.drag,
        drag = _props$drag === void 0 ? false : _props$drag,
        _props$dragDirectionL = props.dragDirectionLock,
        dragDirectionLock = _props$dragDirectionL === void 0 ? false : _props$dragDirectionL,
        _props$dragPropagatio = props.dragPropagation,
        dragPropagation = _props$dragPropagatio === void 0 ? false : _props$dragPropagatio,
        _props$dragConstraint = props.dragConstraints,
        dragConstraints = _props$dragConstraint === void 0 ? false : _props$dragConstraint,
        _props$dragElastic = props.dragElastic,
        dragElastic = _props$dragElastic === void 0 ? defaultElastic : _props$dragElastic,
        _props$dragMomentum = props.dragMomentum,
        dragMomentum = _props$dragMomentum === void 0 ? true : _props$dragMomentum;
      return _objectSpread(_objectSpread({}, props), {}, {
        drag: drag,
        dragDirectionLock: dragDirectionLock,
        dragPropagation: dragPropagation,
        dragConstraints: dragConstraints,
        dragElastic: dragElastic,
        dragMomentum: dragMomentum
      });
    }
  }]);
  return VisualElementDragControls;
}();
function shouldDrag(direction, drag, currentDirection) {
  return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset) {
  var lockThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
export { VisualElementDragControls, elementDragControls };